module.exports = __webpack_public_path__ + "img/logo.bdf5047b.svg";